<template>
  <div>
    <create-attachment-modal
      v-if="showCreateAttachmentModal"
      :registryId="registryId"
      @closeModal="closeModal"
    />
    <delete-attachment-modal
      v-if="showDeleteAttachmentModal"
      :registryId="registryId"
      :attachmentId="attachmentIdSelected"
      @closeModal="closeModal"
    />
    <div class="row border mx-2 pt-3">
      <div class="col-12 mb-2">
        <h5>
          Anexos:
          <span
            v-if="canEditRegistry"
            role="button"
            class="text-primary d-print-none"
            title="Adicionar Novos Anexos"
            @click="createAttachment()"
          >
            (Adicionar)
          </span>
        </h5>
      </div>
      <div class="col-12">
        <ul v-if="attachments.length > 0">
          <li v-for="attachment in attachments" :key="attachment.id">
            <a
              :href="`${baseUrlAttachment}/${attachment.nome}`"
              target="_blank"
              title="Visualizar"
            >
              {{ attachment.nome }}
            </a>
            <span
              v-if="canEditRegistry"
              role="button"
              class="cursor-pointer text-danger d-print-none"
              title="Excluir Anexo"
              @click="deleteAttachment(attachment.id)"
            >
              (Excluir)
            </span>
          </li>
        </ul>
        <p v-else>Nenhuma anexo cadastrado.</p>
      </div>
    </div>
  </div>
</template>

<script>
import CreateAttachmentModal from '@/components/attachments/CreateAttachmentModal.vue'
import DeleteAttachmentModal from '@/components/attachments/DeleteAttachmentModal.vue'

export default {
  name: 'ListAttachments',

  components: {
    CreateAttachmentModal,
    DeleteAttachmentModal,
  },

  props: {
    registryId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      attachments: [],
      showCreateAttachmentModal: false,
      showDeleteAttachmentModal: false,
      attachmentIdSelected: null,
    }
  },

  computed: {
    canEditRegistry() {
      return this.$store.getters.canEditRegistry
    },

    baseUrlAttachment() {
      return `${process.env.VUE_APP_BASE_URL_API}/uploads/rac/${this.registryId}`
    },
  },

  methods: {
    async getAttachments() {
      try {
        this.attachments = await this.$store.dispatch(
          'getAttachments',
          this.registryId,
        )
      } catch (error) {
        if (error && error.message) {
          this.$snotify.warning(error.message, 'Atenção!')
        } else {
          this.$snotify.error(
            'Não foi possível se conectar ao servidor.',
            'Erro!',
          )
        }
      }
    },

    createAttachment() {
      this.showCreateAttachmentModal = true
    },

    deleteAttachment(attachmentId) {
      this.attachmentIdSelected = attachmentId
      this.showDeleteAttachmentModal = true
    },

    closeModal(reloadData) {
      if (reloadData) {
        this.getAttachments()
      }
      this.showCreateAttachmentModal = false
      this.showDeleteAttachmentModal = false
    },
  },

  mounted() {
    this.getAttachments()
  },
}
</script>
